module.exports = __webpack_public_path__ + "img/video-control--pause.8dca3a64.svg";